import { Easing } from 'react-native-reanimated';

export const MIN_SCALE = 1;
export const MAX_SCALE = 3;
export const SWIPE_CLOSE_VELOCITY = 1200;
export const SCALE_EPSILON = 0.05;

// Animation constants
export const SPRING_CONFIG = { damping: 36, stiffness: 320 };
export const CLOSE_TIMING = { duration: 250, easing: Easing.in(Easing.cubic) };
export const OPEN_TIMING = { duration: 300, easing: Easing.out(Easing.cubic) };

// Movement threshold (in points) before pan locks to horizontal or vertical axis when not zoomed
export const PAN_AXIS_LOCK_THRESHOLD = 10;

// Carousel (3-pane track) tuning
// Commit when drag exceeds 25% of screen width OR finger velocity exceeds 500 px/s.
export const SWIPE_COMMIT_RATIO = 0.25;
export const SWIPE_COMMIT_VELOCITY = 500;
// Rubber-band damping factor applied when dragging past the first/last photo.
export const RUBBER_BAND_FACTOR = 0.55;
// Minimum opacity of a neighbor pane when it sits fully off-screen.
export const MIN_PANE_OPACITY = 0.35;
// Snap animation timing for committing or springing back the track.
export const TRACK_SNAP_TIMING = { duration: 220, easing: Easing.out(Easing.cubic) };
// Fade-in duration for the carousel after the open morph completes.
export const CAROUSEL_FADE_IN_DURATION = 80;

// Desktop layout constants
export const DESKTOP_IMAGE_SCALE = 0.8;
export const DESKTOP_HEADER_HEIGHT = 72; // 16px top + 40px content + 16px bottom
export const DESKTOP_CAPTION_RESERVED_HEIGHT = 80;

// Mobile (and small-web) likes/comments overlay layout. The overlay is a fixed
// pill anchored at `bottom: insets.bottom + 16` with a constant rendered height
// (~44px from icon size 28 + py-2). The caption sheet reserves vertical space
// at its bottom so caption text never sits behind the overlay icons. We use a
// hard-coded constant instead of measuring the overlay at runtime because:
//   1) the overlay height is content-independent and doesn't change between
//      photos, so re-measuring per photo just adds layout churn;
//   2) on react-native-web the overlay's onLayout is unreliable when nested in
//      an absolutely-positioned wrapper, so the measured value can stay 0 and
//      the caption then overlaps the overlay (visible as text behind the
//      icons).
// Breakdown: 16 (bottom anchor offset) + 44 (overlay height) = 60. The caption
// sheet adds another ~16 of breathing room on top of this via its own base
// paddingBottom. Bumping iconSize/py-2 in LikesCommentsOverlay above
// 28/2 means this constant must be updated to match.
export const LIKES_OVERLAY_CAPTION_RESERVED_SPACE = 60;
